import {
  Command,
  GameCommandByPlayer as GameCommandByPlayerRaw,
  UndoCommand,
} from "~/utils";
import { Game } from "./Game";
import { EffectChoiceResult } from "./effect";

export const GameApi = (game: Game, playerId: string) => {
  const actions = {
    play: ({
      cardId,
      actionSlotId,
    }: {
      cardId: string;
      actionSlotId: string;
    }) => game.play(playerId, cardId, actionSlotId),
    revealAll: () => game.revealAll(playerId),
    buyCard: (cardId: string) => game.buyCard(playerId, cardId),
    endBuyPhase: () => game.endBuyPhase(playerId),
    answerChoice: (choiceResult: EffectChoiceResult) =>
      game.answerChoice(playerId, choiceResult),
    passIntrigue: () => game.passIntrigue(playerId),
    playIntrigue: (cardId: string) => game.playIntrigue(playerId, cardId),
    playGlobalEffect: () => game.playGlobalEffect(playerId),
    useTech: (techId: string) => game.useTech(playerId, techId),
  };
  return actions;
};

type Api = ReturnType<typeof GameApi>;
export type GameCommand = Command<Api>;
export type GameCommandByPlayer = GameCommandByPlayerRaw<
  GameCommand | UndoCommand
>;

export const getCommandArg = <Key extends keyof Api>(command: GameCommand) =>
  command.arg as Command<Api, Key>["arg"];
